// Turns 'XXXX-XXXX' to decimal.
export default function HrHexToId(Uid) {
  if (Uid === null) return null;
  Uid = `${Uid.slice(0, 4)}${Uid.slice(5, 9)}`;
  Uid = parseInt(Uid, 16);
  return Uid;
}
